const canUseDOM = !!(typeof window !== 'undefined');

const trackNewrelic = (error, customAttributes) => {
  if (canUseDOM && typeof window.newrelic !== 'undefined') {
    window.newrelic.noticeError(error, customAttributes, false);
  }

  return null;
};

export default trackNewrelic;
